import produce from 'immer';
import { BASIC_MISSION_LOG_LIST_REQUEST } from '../../constants/log/basicMissionLogConstants';

const initialState = {

};

const basicMissionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case BASIC_MISSION_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default basicMissionLogReducer;
